import collectedDomains from './domain-data/domains.json';

/** Product output policy; dataset attribution and licenses are in domain-data/NOTICE.md. */
const manualDomains = [
  'xlyl.link', // User-reported advertisement destination.
  'tinyurl.com',
  'bit.ly',
  'cutt.ly',
  't.ly',
  'tiny.cc',
  'shorturl.at',
  'is.gd',
  'v.gd',
  'rebrand.ly',
  'rb.gy',
  'ow.ly',
  'buff.ly',
  't.co',
  't.cn',
  's.id',
];

export const BLOCKED_LINK_DOMAINS: readonly string[] = [...new Set([...collectedDomains, ...manualDomains])].sort();
